import React, { createContext, useContext, useEffect, useState } from 'react';
import httpClient from '../HTTPService';

const SiteSettingContext = createContext(null);

export const SiteSettingProvider = ({ children }) => {
  const [siteSettingData, setSiteSettingData] = useState({});

  const fetchSiteSetting = async () => {
    try {
      const result = await httpClient.post('/admin/site-settings', {}, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      if (result?.data?.data) setSiteSettingData(result.data.data);
    } catch (err) {
      // swallow - consumers can handle errors if needed
    }
  };

  useEffect(() => {
    fetchSiteSetting();
  }, []);

  return (
    <SiteSettingContext.Provider value={{ siteSettingData, setSiteSettingData, fetchSiteSetting }}>
      {children}
    </SiteSettingContext.Provider>
  );
};

export const useSiteSetting = () => useContext(SiteSettingContext);

export default SiteSettingContext;
